/** module-related constants */
export const MAXIMUM_ITEMS_COUNT = 5;
export const MAXIMUM_ITEMS_COUNT_ERROR_CODE = 'maximum';
export const MAXIMUM_ITEMS_COUNT_ERROR_MESSAGE = 'max items count exceeded';

/** actionTypes */
// export const SET_BASKET_CONTENTS = 'Basket::SetBasketContents';
export const ADD_BASKET_ITEM = 'Basket::AddBasketItem';
export const SET_BASKET_DATA = 'Basket::SetBasketData';
// Sources to inform backend from which page item was added to the basket
export const SOURCES = {
  PRODUCT_DETAILS_PAGE: '1075302bdc9ecb495d47e48e85bbd2927a129683',
  PRODUCT_CATALOG_PAGE: '399cfa12e05739d3a63a02584f75de90a0483e16',
  SHOP_MAIN_PAGE: '881723689f949c13cb78bee42443b6c1181acfa5',
  BRAND_ZONE_PAGE: '78fda84d9f5238bc639df4ab626049e13ea6c573',
  SOURCE_NEW_BASKET_RECOMMENDED_PRODUCT: '88bf6d4f401ee32813728cd6e46a2af2c65697a8',
  DETAILS_NEW_BASKET: '00dbed635e74e4adc23d471c7db17eca48ab96ac',
  DETAILS_PAGE_RECOMMENDED: '5face0c403a49e1dce108e8df3a711daabf9e843',
  CATALOG_AND_MAIN_PAGE_POPUP: '1e3813abc708703a02a0858fe0ed8e7e2702d2a5',
  MAIN_PAGE_RECOMMENDED: '9fabdd75fcda60f80a64cdc1fbf064250b5a646e',
  COMPARISON_PAGE: '23f3795f4efac1911b8fd03a3ee2c69a8696263c',
  COMPARISON_PAGE_POPUP: 'f23c7f7158ecbd0f1f5cf5188ec2d87ccbc49d83',
  FAVORITE_PAGE: '78e0f50be03b82e18e330b18f64cd1234ba829e7',
  FAVORITE_PAGE_POPUP: 'e22f3216bd0ad69e24e5922063fee785cebd7e26',
};

export const SOURCES_NAMES = {
  PRODUCT_DETAILS_PAGE: 'PRODUCT_DETAILS_PAGE',
  PRODUCT_CATALOG_PAGE: 'PRODUCT_CATALOG_PAGE',
  SHOP_MAIN_PAGE: 'SHOP_MAIN_PAGE',
  BRAND_ZONE_PAGE: 'BRAND_ZONE_PAGE',
  DETAILS_PAGE_RECOMMENDED: 'DETAILS_PAGE_RECOMMENDED',
  CATALOG_AND_MAIN_PAGE_POPUP: 'CATALOG_AND_MAIN_PAGE_POPUP',
  MAIN_PAGE_RECOMMENDED: 'MAIN_PAGE_RECOMMENDED',
  COMPARISON_PAGE: 'COMPARISON_PAGE',
  FAVORITE_PAGE: 'FAVORITE_PAGE',
  COMPARISON_PAGE_POPUP: 'COMPARISON_PAGE_POPUP',
  FAVORITE_PAGE_POPUP: 'FAVORITE_PAGE_POPUP',
};

export const SET_COMMON_LOADING = 'Common::SetCommonLoading';
